<template>
    <van-image :class="[classOption,{'round': round,'long':long}]" :src="src" @load="onLoaded" @error="onError" v-lazy="src">
        <template v-slot:loading>
            <img src="@/assets/origin/origin.png" alt="">
        </template>
        <template v-slot:error>
            <img src="@/assets/origin/origin.png" alt="">
        </template>
    </van-image>
</template>

<script>
    export default {
        name: 'vue-img',
        props: {
            classOption: String,
            src: String,
            round: {
                type: Boolean,
                default: false
            },
            long: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            //图片加载完成触发
            onLoaded(){
                this.$emit('Loaded', true);
            },
            onError(){
                this.$emit('Errored', true);
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.van-image {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.round {
    border-radius: 50%;
}
.long {
    .van-image__loading {
        img {
            height: 55%;
            width: auto;
        }
    }
}
</style>